import React from 'react'
import Button from 'components/Button'
import ScheduleinterviewIcon from 'components/icons/ScheduleInterviewIcon'
import {
  UploadMsgFlex,
  ResultIconDiv,
  ResultDiv,
  ButtonDiv,
  // FileTextSpan,
  FileInfoDiv,
} from './style'
import {
  StyledDrawer,
} from 'modules/Roles/Style/style'


const SuccessNegotiateOfferDrawer  = ({
  drawer,
  setDrawer,
}) => {


  const content = () => {
    return (
    
        <UploadMsgFlex column center centerVertically>
      <ResultIconDiv>
        <ScheduleinterviewIcon />
      </ResultIconDiv>
      <ResultDiv>Negotiation Sent Successfully</ResultDiv>

      <FileInfoDiv>
      Salary negotiation request with expected salary has been sent successfully
      </FileInfoDiv>

      <ButtonDiv>
        <Button.Secondary
          text="Close"
          width="80px"
          height="36px"
          onClick={() => {
            setDrawer(false)
          }}
        />
      </ButtonDiv>
    </UploadMsgFlex>
    
    )
  }
 
  return (
  
      <StyledDrawer
        width="600px"
        title={'Negotiation'}
        placement="right"
        closable={true}
        onClose={() => setDrawer(false)}
        visible={drawer}
        content={content()}
    
      />
    
  )
}

export default SuccessNegotiateOfferDrawer 
